import { api_get, api_post } from "./utils"
// import { dispatch_api_result } from "./data"

const ConvoAPI = {
	load: _loadConvo,
    loadList: _loadConvoList,
	loadCommentList: _loadCommentList,
    sendComment: _sendComment,
}

async function _loadConvo(key : string) {

	if (!key) {
		return null;
	}
	return api_get("/convo/" + key).then((res) => {
		if(!res.ok) {
			return null;
		}
		else {
			return res.json();
		}
	});
}


async function _loadConvoList(projectKey : string) {
	return api_get(`/project/${projectKey}/convos`).then((res) => {
		if(!res.ok) {
			return null;
		}
		else {
			return res.json();
		}
	});
}

async function _loadCommentList(key : string) {
	return api_get('/convo/' + key + '/comments').then((res) => {
		if(res.ok) {
			return res.json();
		}
	});
}

async function _sendComment(projectKey: string, key : string, textContent : string) {
	return api_post('/convo/comment', { "comment": textContent, "convo_key": key, "project_key": projectKey })
		.then(async (res) => {
			if(res.ok) {
				return await res.json();
			}
		});

}

export default ConvoAPI;
